import { HelperResult } from '@openclassrooms/sdk-web';
import type { FundingProgramRecommendation } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useFundingProgramRecommendations } = getCRUDHooks({
  entityName: 'userFundingProgramRecommendations',
  find: ({ userId }): HelperResult<FundingProgramRecommendation[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).fundingProgramRecommendations.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useFundingProgramRecommendations };
